<template>
	    <div>
			<el-dialog :title="title" custom-class="logClass" :append-to-body="append_body" :visible.sync="logDialogVisible" width="70%">
			   <el-row>
					<h3>操作日志</h3>
					<el-table :data="tableData" border v-loading="listLoading" style="width:100%">
					  <el-table-column prop="create_time" label="操作时间" width="250"></el-table-column>
					  <el-table-column prop="object_type" label="操作类型"></el-table-column>					 
					  <el-table-column prop="content_title" label="操作内容"></el-table-column>
					  <el-table-column prop="operator" label="操作人"></el-table-column>
					</el-table>
					<el-col :span="24">
					<div style="text-align:right;margin:15px 0px;">
					  <el-pagination					 
					  :current-page.sync="page"
					   @current-change="handleCurrentChange"
					  :page-size="pagesize"
					  layout="total, prev, pager, next, jumper"
					  :total="total">
					</el-pagination>
					</div>
					</el-col>
			   </el-row>			
			</el-dialog>
			
		</div>
</template>
<script>
	import { getLogPage } from '../../../../api/api';
	export default {		
		props:{
		  
		},		
		data() {
			return {
				total:0,
				keyword:'',
				page:1,
				title:'操作日志',
				pagesize:10,				
				tableData:[],
				listLoading:false,
				advertiser_ids:'',
				logDialogVisible:false,
				row:{},
				append_body:true
			}
		},
		computed:{
		   advertiser_id(){
		     return this.$store.getters.getAdvertiserId
		   },
		   userid(){
		    return this.$store.getters.getUserId
		   }
		},
		methods: {			
			openModel(row){
			 this.logDialogVisible = true
			 this.title ='广告计划:'+row.name
			 this.row = row
			 this.getLog(row.advertiser_id,row.ad_id)
			},
			handleCurrentChange(val){
			  let row = this.row
			  this.getLog(row.advertiser_id,row.ad_id)
			},
			getLog(advertiser_id,ad_id){
			  let params ={
			    advertiser_id:advertiser_id,
				object_id:ad_id,
				type:'ad_id',
				page:this.page,
				pagesize:this.pagesize
			  }
			  this.listLoading = true
			  getLogPage(params).then((res) => {
					this.listLoading = false
					this.tableData = res.data.logs
                    this.total = res.data.page_info.total_number					
			 });
			}
		},
		mounted() {
			
		}
	}

</script>
<style  lang="scss">
.logClass .el-dialog__body{padding: 0px 20px;}
</style>


// WEBPACK FOOTER //
// log.vue?6cafc228